import React from 'react'

export const MiniPlayIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M29 18.2679C30.3333 19.0377 30.3333 20.9623 29 21.7321L17 28.6603C15.6667 29.4301 14 28.4678 14 26.9282L14 13.0718C14 11.5322 15.6667 10.5699 17 11.3397L29 18.2679Z" fill="#606E8A" />
  </svg>
)
